/**
 * @generated SignedSource<<b358e269d0478b43a03531bbd23569d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlyerScreenDeletePollFileMutation$variables = {
  id: string;
};
export type IntegrationFlyerScreenDeletePollFileMutation$data = {
  readonly store: {
    readonly deleteIntegrationPollFile: boolean | null;
  };
};
export type IntegrationFlyerScreenDeletePollFileMutation = {
  response: IntegrationFlyerScreenDeletePollFileMutation$data;
  variables: IntegrationFlyerScreenDeletePollFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ScalarField",
        "name": "deleteIntegrationPollFile",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlyerScreenDeletePollFileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationFlyerScreenDeletePollFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2494b8d780165d2791ac24e4d5e60f0e",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlyerScreenDeletePollFileMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlyerScreenDeletePollFileMutation(\n  $id: ID!\n) {\n  store {\n    deleteIntegrationPollFile(id: $id)\n  }\n}\n"
  }
};
})();

(node as any).hash = "88c90203a005ee44d9800d3a556146b3";

export default node;
